<div class="h-full flex flex-col items-center justify-center bg-fancy">
  <div class="px-7 pb-5 pt-10 rounded-4 bg-white shadow-3 bg-opacity-95">
    <cac-login-form [logo]="logo"></cac-login-form>
  </div>
</div>
